<style lang="less" scoped>
.margin-tb {
  height: 32px;
  margin-top: 4px;
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">共享开关设备列表</div>
      <div class="page-action-btns flex margin-tb-10">
        <button class="common-bg-button" @click="editDialog()">查看</button>
        <!-- <button class="common-bg-button" @click="Unbinding">解绑</button> -->
        <div class="flex-grow-1"></div>
        <button class="common-bg-button" @click="
          () => {
            showMultiQuerys = !showMultiQuerys;
          }
        ">
          高级筛选
        </button>
        <button class="common-bg-button" @click="getListData(pagination, true)">
          搜 索
        </button>
        <button class="common-bg-button" @click="toExportList">
          导 出
        </button>
        <button class="common-bg-button" @click="reset()">重 置</button>
      </div>
      <!-- 高级筛选 -->
      <div class="multi-query-div el-fade-in-linear" v-if="showMultiQuerys">
        <div class="margin-bottom-16">
          <el-row :gutter="20">
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">设备名称</p>
              <el-input v-model="queryInfo.shareStationName" size="small" clearable placeholder="请输入" />
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">共享开关型号</p>
              <el-input clearable v-model="queryInfo.typeName" size="small" placeholder="请输入" />
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">当前共享状态</p>
              <el-select class="full-width" size="small" v-model="queryInfo.shareMode" clearable placeholder="请选择">
                <el-option label="共享" value="SHARE" />
                <el-option label="自用" value="SELF" />
              </el-select>
            </el-col>
            <!-- <el-col :span="6">
              <p class="margin-bottom-5 font-14">共享开关实时状态</p>
              <el-select class="full-width" size="small" v-model="queryInfo.shareLocalStatus" clearable
                placeholder="请选择充电桩状态">
                <el-option label="登录" value="10" />
                <el-option label="充电中" value="11" />
                <el-option label="空闲中" value="14" />
                <el-option label="故障" value="15" />
                <el-option label="枪已连接车" value="16" />
                <el-option label="离线" value="22" />
                <el-option label="充电等待中" value="19" />
              </el-select>
            </el-col> -->
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">关键字</p>
              <el-input v-model="queryInfo.deviceCode" size="small" clearable placeholder="请输入充电桩编号/IMEI号" />
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">所属用户</p>
              <el-input v-model="queryInfo.custMobile" size="small" clearable placeholder="请输入用户手机号" />
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">是否开通私桩共享</p>
              <el-select class="full-width" size="small" v-model="queryInfo.shareActive"
                @change="handleShareActiveChange" clearable placeholder="请选择">
                <el-option label="是" value="1" />
                <el-option label="否" value="0" />
              </el-select>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">绑定渠道</p>
              <el-select class="full-width" size="small" v-model="queryInfo.bindChannelStatus"
                :disabled="queryInfo.shareActive === '0'" clearable placeholder="请选择">
                <el-option label="挚达APP" value="01" />
                <el-option label="挚达支付宝小程序" value="02" />
                <el-option label="桩到家个人站支付宝小程序" value="03" />
                <el-option label="桩到家个人站微信小程序" value="04" />
              </el-select>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">绑定时间</p>
              <div class="flex-r">
                <el-date-picker v-model="queryInfo.bindStartDate" type="date" size="small" placeholder="开始日期"
                  value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                <div class="separate-center-div"></div>
                <!-- :picker-options="pickerEndOptions" -->
                <el-date-picker v-model="queryInfo.bindEndDate" type="date" size="small" placeholder="结束日期"
                  value-format="yyyy-MM-dd 23:59:59"></el-date-picker>
              </div>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">最近订单开始充电时间</p>
              <div class="flex-r">
                <el-date-picker v-model="queryInfo.openShareStartDate" type="date" size="small" placeholder="开始日期"
                  value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                <div class="separate-center-div"></div>
                <!-- :picker-options="pickerEndOptions" -->
                <el-date-picker v-model="queryInfo.openShareEndDate" type="date" size="small" placeholder="结束日期"
                  value-format="yyyy-MM-dd 23:59:59"></el-date-picker>
              </div>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">剩余补贴发放时间</p>
              <div class="flex-r">
                <el-date-picker v-model="queryInfo.disbursementStartTime" type="date" size="small" placeholder="开始日期"
                  value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                <div class="separate-center-div"></div>
                <!-- :picker-options="pickerEndOptions" -->
                <el-date-picker v-model="queryInfo.disbursementEndTime" type="date" size="small" placeholder="结束日期"
                  value-format="yyyy-MM-dd 23:59:59"></el-date-picker>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- 表格 -->
      <div class="list-table">
        <ZD-table :tableColumns="pageConfig.listColumns" :operates="operates" :tableData="tableData"
          :tableConfig="pageConfig.tableConfig" :selections="selections" v-on:updateSelections="
            (sels) => {
              selections = sels;
            }
          "></ZD-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData" />
      </div>

      <el-dialog title="提示" :visible.sync="centerDialogVisible" width="24%" center>
        <span>是否确认解绑充电桩，点击确认则解绑，点击取消则关闭弹框</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="unBindPile">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import pageConfig from "./page-config";
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      tableData: [], // 表格数据
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      showMultiQuerys: false, //高级筛选
      queryInfo: {}, // 搜索字段
      centerDialogVisible: false,
      operates: {
        width: 220,
        fixed: "right",
        list: [],
      },
    };
  },
  methods: {
    init() {
      this.getListData(this.pagination, true);
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this;
      _.$U.showLoading(_);
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        this.pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.corpNo = "CO1524100773815";
      _.$H
        .post(_, _.$A.digitization.getShareDevicePage, _.queryInfo)
        .then((res) => {
          _.tableData = res.data.data.content || [];
          _.pagination.total = res.data.data.totalElements || 0;
          _.$U.hideLoading(_);
        });
    },
    // 页面编辑方法
    editDialog() {
      if (this.checkSelectOne()) {
        this.$store.commit("setPileObj", this.selections[0]);
        console.log(this.selections[0]);
        let url = this.$router.resolve({
          name: "shareSwitchDetail",
          query: {
            parent: 1,
          },
        });
        window.open(url.href, "_blank");
      }
    },
    Unbinding() {
      if (this.checkSelectOne()) {
        if (this.selections[0].pileStatusName == "待机") {
          this.centerDialogVisible = true;
        } else {
          this.$U.error("充电桩状态非空闲 无法解绑");
        }
      }
    },
    unBindPile() {
      let _ = this;
      let obj = {
        pileCode: _.selections[0].pileCode,
        corpNo: "CO1524100773815",
        userPhone: _.selections[0].userPhone,
      };
      _.$H.post(_, _.$A.digitization.unBindPile, obj).then((res) => {
        this.$U.success("解绑成功");
        this.centerDialogVisible = false;
      });
    },
    //选择表格
    checkSelectOne() {
      if (this.selections.length < 1) {
        this.$U.error("请选择需要操作的对象");
        return false;
      }
      if (this.selections.length > 1) {
        this.$U.error("只能选择一个操作的对象");
        return false;
      }
      return true;
    },
    //重置
    reset() {
      this.pagination.current = 1;
      this.queryInfo = {};
      this.getListData(this.pagination, true);
    },
    // 处理是否开通私桩共享变化
    handleShareActiveChange(value) {
      // 如果选择"否"，清空绑定渠道
      if (value === "0") {
        this.queryInfo.bindChannelStatus = "";
      }
    },
    // 导出
    toExportList() {
      let _ = this;
      const params = {
        ..._.queryInfo,
        corpNo: "CO1524100773815",
      };
      _.$U.showLoading(_);
      axios
        .post(_.$A.digitization.exportDeviceShareLockList, params, {
          responseType: "blob",
          headers: {
            authorization: _.$store.state.token,
          },
        })
        .then((res) => {
          const disposition = res.headers["content-disposition"] || "";
          const match = disposition.match(/filename\*=UTF-8''(.+)|filename="?([^"]+)"?/);
          const fileName = decodeURIComponent(match?.[1] || match?.[2] || "共享开关设备列表.xlsx");
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .finally(() => {
          _.$U.hideLoading(_);
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
